/** @jsxImportSource @emotion/react */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ControlBtnGroup,
  GlobalBtnGroup,
  SubTitleGroup,
  SubTitleLayout,
} from 'components/layouts/ContentLayout';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'hooks/useMessageBar';
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import { tb } from 'components/layouts/Table';
import _ from 'lodash';
import { useCommonModal } from 'hooks/useCommonModal';
import { DefaultProps } from '../MdIvesCmpuRegPage';
import CustomRadio from 'components/inputs/CustomRadio';
import { st } from 'components/inputs/CustomInput';

const IvesResultPage = ({ elmPrjId }: DefaultProps) => {
  const { t } = useTranslation();
  const { isLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const { openCommonModal } = useCommonModal();

  const [version, setVersion] = useState('');
  const [resultData, setResultData] = useState([]);
  const [mainSpec, setMainSpec] = useState({});
  const [summary, setSummary] = useState([]);
  const [rankList, setRankList] = useState([]);

  const layoutDefinition = [
    { title: t('setup.label.공정', '공정'), width: '' },
    { title: t('setup.label.설비군', '설비군'), width: '' },
    { title: t('setup.label.투자항목', '투자항목'), width: '' },
    { title: t('setup.label.설비대수', '설비대수'), width: '' },
    { title: t('setup.label.단가', '단가'), width: '' },
    { title: t('setup.label.투자비', '투자비'), width: '' },
  ];

  const initCodes = () => {
    //
  };

  const btnList = () => {
    //
  };

  const btnReset = () => {
    //
  };

  const btnSave = () => {
    //
  };

  const handleOnChange = (name: string, value: any) => {
    //
  };

  useEffect(() => {
    initCodes();
  }, []);

  return (
    <>
      <SubTitleLayout>
        <div>
          <CustomRadio
            id="ver-radio1"
            label={'Ford 1.0'}
            name="version"
            value={'1'}
            checked={version === '1'}
            onChange={(e) => handleOnChange('version', e.target.value)}
          />
          <CustomRadio
            id="ver-radio2"
            label={'Ford 2.0'}
            name="version"
            value={'2'}
            checked={version === '2'}
            onChange={(e) => handleOnChange('version', e.target.value)}
          />
          <CustomRadio
            id="ver-radio3"
            label={'Ford 3.0'}
            name="version"
            value={'3'}
            checked={version === '3'}
            onChange={(e) => handleOnChange('version', e.target.value)}
          />
        </div>
        <GlobalBtnGroup>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={btnList}>
            {t('com.button.목록', '목록')}
          </Button>
          <Button css={IconButton.button} className="save" disabled={isLoading} onClick={btnSave}>
            {t('com.label.저장', '저장')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.형개발 투자비 산출 결과', '형개발 투자비 산출 결과')}</h3>
        </SubTitleGroup>
      </SubTitleLayout>
      <TableContainer css={tb.tableCol}>
        <Table>
          <TableHead>
            <TableRow>
              {layoutDefinition.map((item, idx) => {
                return (
                  <TableCell key={idx} width={item.width}>
                    {item.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(10).map((item, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                  <TableCell>{idx}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default IvesResultPage;
